angular
    .module('quattro.bmbo.email.modal-edit', [
        'quattro.bmbo.email.model',
        'quattro.bmbo.email.form',
        'quattro.core.alert.service',
        'quattro.core.myModal',
    ])
    .run(['$rootScope', 'Email', 'myModalService', function ($rootScope, Email, myModalService) {

        $rootScope.$on('vq.bmbo.email.edit', function (event, email) {

            // reflect modal state on email's scope
            email.$active = true;

            var model = new Email(email);
            model.get();

            myModalService.showModal({
                templateUrl: 'bmbo/email/modal-edit.html',
                controller: 'ModalEditBmboEmailController',
                inputs: {
                    model: model,
                }
            }).then(function (modal) {
                modal.close.then(function () {
                    email.$active = false;
                });
            });

        });
    }])
    .controller('ModalEditBmboEmailController', function ($scope, close, alertService, model, $translate) {

        $scope.data = model.data;


        $scope.cancel = close;

        $scope.save = function () {

            var promise = model.update();
            promise.then(
                function () {
                    alertService.add('success', 'Email gespeichert.');
                    close({
                        model: model,
                    });
                    document.dispatchEvent(new Event("email updated"));
                },
                function (errorData) {

                    var message = $translate.instant('EMAIL.email_save_error');

                    if (errorData.hasOwnProperty('code') && errorData.code === 398) {
                        if (errorData.data && errorData.data.includes("capability")) {
                            message = $translate.instant('EMAIL.downgrade_error') + ' ' +
                                $translate.instant('EMAIL.capability_error');
                        } else if (errorData.data && errorData.data[0] && errorData.data[0].allowed) {
                            message = $translate.instant('EMAIL.downgrade_error') + ' ' +
                                $translate.instant('EMAIL.too_many_aliases')
                                    .replace('%max%', errorData.data[0].allowed)
                                    .replace('%current%', errorData.data[0].used);
                        } else {
                            message = $translate.instant('EMAIL.downgrade_error') + ' ' +
                                $translate.instant('EMAIL.unkown_downgrade_error');
                        }
                    }

                    alertService.add('error', message);
                }
            );
        };
    });
